import React from "react";

export const AuthHeader = ({ user, signOut, signInWithGoogle }) => {
  const { uid, displayName, photoURL, email, createdAt, lastLoginAt } =
    user || {};
  return (
    <div className="absolute top-0 right-0 mt-6 mr-6">
      {user && (
        <div>
          {displayName}{" "}
          <button className="underline" onClick={signOut}>
            logout
          </button>
        </div>
      )}
      {!user && (
        <button
          className="bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-400 rounded shadow"
          onClick={signInWithGoogle}
        >
          Sign in with Google
        </button>
      )}
    </div>
  );
};

export default AuthHeader;
